import { supabase } from "./supabase";

export interface WhatsAppMessage {
  id: string;
  user_id: string | null;
  phone: string;
  direction: "in" | "out";
  body: string | null;
  message_sid: string | null;
  intent: string | null;
  twilio_status: string | null;
  created_at: string;
}

export interface BlockedNumber {
  id: string;
  phone: string;
  reason: string | null;
  blocked_by_admin_id: string | null;
  blocked_at: string;
}

export async function listMessagesForUser(userId: string): Promise<WhatsAppMessage[]> {
  const { data, error } = await supabase
    .from("whatsapp_messages").select("*").eq("user_id", userId)
    .order("created_at", { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listMessages(filters: { intent?: string; from?: string; to?: string; userId?: string }): Promise<WhatsAppMessage[]> {
  let q = supabase.from("whatsapp_messages").select("*").order("created_at", { ascending: false }).limit(500);
  if (filters.intent) q = q.eq("intent", filters.intent);
  if (filters.userId) q = q.eq("user_id", filters.userId);
  if (filters.from) q = q.gte("created_at", filters.from);
  if (filters.to) q = q.lte("created_at", filters.to);
  const { data, error } = await q;
  if (error) throw error;
  return data ?? [];
}

export async function listBlockedNumbers(): Promise<BlockedNumber[]> {
  const { data, error } = await supabase
    .from("whatsapp_blocked_numbers").select("*").order("blocked_at", { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function addBlockedNumber(phone: string, reason: string, adminUserId: string | null): Promise<void> {
  const { error } = await supabase.from("whatsapp_blocked_numbers")
    .insert({ phone, reason: reason || null, blocked_by_admin_id: adminUserId });
  if (error) throw error;
}

export async function removeBlockedNumber(id: string): Promise<void> {
  const { error } = await supabase.from("whatsapp_blocked_numbers").delete().eq("id", id);
  if (error) throw error;
}
